import { render, staticRenderFns } from "./SocialSectionInstagramGrid.vue?vue&type=template&id=ab8b484a"
import script from "./SocialSectionInstagramGrid.vue?vue&type=script&setup=true&lang=ts"
export * from "./SocialSectionInstagramGrid.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports